import React from 'react';
import styles from './Logo.module.css';
import LogoIcon from '../images/Logo.png'

function Logo() {
  return (
    <a className={styles.logoContainer} href='/'>
      <img src={LogoIcon} alt="Isiko logo" className={styles.logoImage} />
    </a>
  );
}

export default Logo;